import { createFileRoute, redirect } from '@tanstack/react-router'
import { assistantSearchSchema } from '../../../src/schemas/routeSchemas'

export const Route = createFileRoute('/assistant/')({
  validateSearch: (search) => assistantSearchSchema.parse(search),
  loaderDeps: () => ({}),
  beforeLoad: () => {
    throw redirect({ to: '/assistant/case-search' })
  },
})
